module.exports = __webpack_public_path__ + "ecf88c5913418e5f1eb70946e9c04aec.svg";